/*============================================================
  REACT DEPENDENCIES
============================================================*/
import { useState, useEffect } from "react";

/*============================================================
  REDUX DEPENDENCIES
============================================================*/
import { useDispatch, useSelector } from "react-redux";

/*============================================================
  MATERIAL UI
============================================================*/
import Box from "@mui/material/Box";
import { FormControl } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import Grid from "@mui/material/Grid2";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";

/*============================================================
  PROPRIETARY - COMPONENTS
============================================================*/
import SectionApplicants from "./SectionApplicants";
import SectionNameAndIdentification from "./SectionNameAndIdentification";
import SectionPersonalInformation from "./SectionPersonalInformation";
import SectionContact from "./SectionContact";
import SectionResidential from "./SectionResidential";
import SectionEmploymentAndEducation from "./SectionEmploymentAndEducation";
import SectionLanguages from "./SectionLanguages";

import GridDropdown from "../../widgets/GridDropdown";
import GridCheckbox from "../../widgets/GridCheckbox";
import GridSectionHeader from "../../widgets/GridSectionHeader";
import GridSection from "../../widgets/GridSection";
import GridTextfield from "../../widgets/GridTextfield";

import PageNavigator, { onNext } from "../../PageNavigator";

/*============================================================
  PROPRIETARY - REDUX DATA SLICES
============================================================*/
import { updateApplication } from "../../../states/slcApplication.js";
import { updateClientInfo } from "../../../states/slcPersonalInformation.js";

/*============================================================
  PROPRIETARY - DATA MODELS
============================================================*/
import { createPersonalInfo } from "./PersonalInfoModel.js";

/*============================================================
  PROPRIETARY - UTILS
============================================================*/
import { reNumbers, reEmail, alphanum } from "../../../utils/fieldValidator.js";
import { createPayload, createReduxAction } from "../../../utils/modelHelper.js";

import countryPhoneCode from "../../../data/countryPhoneCodes.json";
import { ConstructionOutlined, IndeterminateCheckBoxOutlined } from "@mui/icons-material";

const titleData = [
  { key: "MR", value: "Mr" },
  { key: "MRS", value: "Mrs" },
  { key: "MDM", value: "Mdm" },
  { key: "MS", value: "Mdm" },
  { key: "DR", value: "Dr" },
];

const raceData = [
  { key: "CHI", value: "Chinese" },
  { key: "IND", value: "Indian" },
  { key: "MAL", value: "Malay" },
  { key: "OTH", value: "Others" },
];

const genderData = [
  { key: "M", value: "Male" },
  { key: "F", value: "Female" },
];

const identityTypeData = [
  { key: "NRIC", value: "NRIC" },
  { key: "Passport", value: "Passport" },
  { key: "FIN", value: "FIN" },
];

const maritalStatusData = [
  { key: "S", value: "Single" },
  { key: "M", value: "Married" },
  { key: "W", value: "Widowed" },
  { key: "D", value: "Divorced" },
];

const sgResidentialStatus = [
  { key: "SINGAPOREAN", value: "Singaporean" },
  { key: "SINGAPOREPR", value: "SingaporePR" },
  { key: "OTHERS", value: "Others" },
];

const employmentStatusData = [
  { key: "FULLTIME", value: "Full Time" },
  { key: "PARTTIME", value: "Part Time" },
  { key: "SELFEMPLOYED", value: "Self Employed" },
  { key: "RETIRED", value: "Retired" },
  { key: "OTHERS", value: "Others" },
];

const highestQualificationData = [
  { key: "PRIMARY", value: "Primary" },
  { key: "SECONDARY", value: "Secondary" },
  { key: "NOLEVELS", value: "N/O Levels" },
  { key: "DIPLOMA", value: "Post Sec/A levels/Diploma" },
  { key: "TERTIARY", value: "Degree and Above" },
];

const booleanData = [
  { key: "Y", value: "Yes" },
  { key: "N", value: "No" },
];

function validateForm() {}

export default function PersonalInfo() {
  const app = useSelector((state) => state.app);
  const personalInfo = useSelector((state) => state.personalInformation);
  const [numberOfApplicants, setNumberOfApplicants] = useState(app.applicantCount);

  const [isValid, setIsValid] = useState(false);

  return (
    <>
      <Box component="form" onSubmit={validateForm} noValidate>
        {/*================================================================================
          NUMBER OF APPLICANTS
          ================================================================================*/}
        <SectionApplicants />

        {/* <Grid container spacing={2}>
          <GridSection columnSize={12}>
            <GridSectionHeader sectionName="Number of Applicants" />

            <Typography variant="body1">Number of applicants in this financial Analysis?</Typography>

            <RadioGroup
              id="numberofapplicants"
              name="numberofapplicants"
              defaultValue=""
              value={numberOfApplicants}
              onChange={handleChange}
              sx={{ mx: "100" }}
            >
              <FormControl>
                <Stack direction="row">
                  <FormControlLabel id="singleApplicant" value="ONE" control={<Radio />} label="One" />
                  <FormControlLabel id="multiApplicant" value="TWO" control={<Radio />} label="Two" />
                </Stack>

                {numberOfApplicantsError ? (
                  <FormHelperText error={numberOfApplicantsError}>Number of applicant(s) required.</FormHelperText>
                ) : (
                  ""
                )}
              </FormControl>
            </RadioGroup>
          </GridSection>
        </Grid> */}

        {/*================================================================================
          NAME AND IDENTIFICATION
          ================================================================================*/}
        <SectionNameAndIdentification />

        {/*================================================================================
          CONTACT
          ================================================================================*/}
        <SectionContact />

        {/*================================================================================
          RESIDENTIAL
        ================================================================================*/}
        <SectionResidential />

        {/*================================================================================
          EMPLOYMENT & EDUCATION
        ================================================================================*/}
        <SectionEmploymentAndEducation />

        {/*================================================================================
          LANGUAGES
        ================================================================================*/}
        <SectionLanguages />

        <PageNavigator validator={validateForm} isValid={isValid} />
      </Box>
    </>
  );
}
